module.exports = __webpack_public_path__ + "img/fedex.ece499d1.svg";